module.exports = __webpack_public_path__ + "static/amazonia_maquinas_logo-b2585e936dd583b54be8c10fe3383a85.png";